import CurvedLineIcon from 'app/assets/icons/blog/curved-line.svg'
import StraightLineIcon from 'app/assets/icons/blog/straight-line.svg'
import Box, { BoxProps } from 'app/components/base/Box'
import Container from 'app/components/base/Container'

interface BackgroundContainerProps {
  sx?: BoxProps['sx']
}

const BackgroundContainer: RFC<BackgroundContainerProps> = ({
  children,
  sx
}) => {
  return (
    <Box
      sx={{
        position: 'relative',
        isolation: 'isolate',
        backgroundColor: 'background.blog',
        ...sx
      }}
    >
      <Box
        aria-hidden
        id="icons"
        sx={{
          position: 'absolute',
          top: 0,
          right: 0,
          zIndex: -1,
          display: { xs: 'none', lg: 'block' }
        }}
      >
        <CurvedLineIcon
          style={{ position: 'absolute', top: '105px', right: '0' }}
        />

        <StraightLineIcon
          style={{ position: 'absolute', top: '0', right: '0' }}
        />
      </Box>

      <Container
        sx={{
          pt: '40px',
          pb: { xs: '56px', md: '86px' },
          maxWidth: { xs: '920px' }
        }}
      >
        {children}
      </Container>
    </Box>
  )
}

export default BackgroundContainer
